<template>
  <div class="shopNews">
    <div class="shopTop">
      <div class="topLeft">
        <div class="login" @click="goLogin">亲，请登录</div>
        <div class="register" @click="goRegister">免费注册</div>
        <div class="home" @click="goHome">首页</div>
      </div>
      <div class="topRight">
        <div class="aboutUs" @click="goAboutUs">关于我们</div>
        <div class="contactUs" @click="goContactUs">联系我们</div>
        <div class="news" @click="goNews">资讯</div>
        <div class="enter" @click="goEnter">商家入驻</div>
      </div>
    </div>
    <div class="shopSearch">
      <div class="shopLogo">
        <img src="../../../../static/img/ejklogo_01.png" alt="">
      </div>
      <div class="search">
        <el-input placeholder="请输入内容" v-model="input3" class="input-with-select">
          <el-button slot="append" icon="el-icon-search"></el-button>
        </el-input>
      </div>
      <div class="shopLogo">
        <img src="" alt="">
      </div>
    </div>
    <div class="shopGoods">
      <div class="goodsLeft">
        <div class="leftTitle">热文推荐</div>
        <div class="leftCont" v-for="(item,index) in newsList" :key=index @click="goQrCode">
          <img :src="item.src" alt="">
          <div class="newsMsg">
            <div class="itemTitle">
              {{ item.title }}
              <p class="itemPayNum">{{ item.payNum }}</p>
            </div>
            <div class="itemMsg">{{ item.msg }}</div>
            <div class="itemPeople">{{ item.people }}</div>
          </div>
        </div>
      </div>
      <!-- <img src="../../../../static/img/shopNews.png" alt=""> -->
    </div>
    <div class="pay" v-show="isPayShow">
      <div class="payName">微信支付</div>
      <div class="payQrCode">
        <img src="../../../../static/img/wechatPay.png" alt="">
      </div>
      <div class="payClose" @click="goClosePay">
        <img src="../../../../static/img/guanbi-2.png" alt="">
      </div>

    </div>
    <div style="height:5rem"></div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        input3: '',
        isPayShow: false,
        newsList: [ //热文推荐
          {
            src: require("../../../../static/img/shopNews_03.png"),
            title: "简约与实用的结合，联想KM4800键鼠套装",
            msg: "我们都有自己独特的个性，不同性格就有不同想法和选择，就拿办公必备的键鼠来说，对于它们百变的风格，每个人都有自己不同的选择，对于办公场景来说，人们大多会选择简约时尚类型的，本期就向大家介绍一款这样的键鼠套装——联想KM4800有线键鼠套装。",
            people: "7.9万人浏览",
            payNum:"查看更多，3元/篇",
          },
          {
            src: require("../../../../static/img/shopNews_06.png"),
            title: "可以“变形”的无线鼠标——联想N700",
            msg: "本期向大家介绍一款特别的鼠标，为什么说它特别呢？因为它可以“变形”，不光是一个鼠标，还是一个演示器。",
            people: "8万人浏览",
            payNum:"查看更多，4元/篇",
          },
          {
            src: require("../../../../static/img/shopNews_08.png"),
            title: "讨好挑剔女友，这几款智能礼物助你虏获女人心~",
            msg: "现在有很多多功能智能家电，这无疑让人们眼前一亮。它们不仅多功能，而且值得在线使用。我们不妨送一些实用又智能的高性价比小家电来提升她的生活质量，帮助你赢得女友的青睐，所以即使你对女友很挑剔，你也会为你的浪漫喝彩！",
            people: "7.9万人浏览",
            payNum:"查看更多，3元/篇",
          },
        ],
      }
    },
    methods: {
      //去登陆
      goLogin() {
        this.$router.push({
          path: "/shopLogin",
        })
      },
      //去注册
      goRegister() {
        this.$router.push({
          path: "/shopRegister",
        })
      },
      //去关于我们
      goAboutUs() {
        const m = this.$createElement;
        this.$msgbox({
          title: '关于我们',
          message: m('p', null, [
            m('p', null, '金科生活商城，是e金科平台为您提供的综合生态服务，守护您关爱的每一个生活细节；快入手巧成团，与您的挚爱亲朋玩转金科生活圈。'),
            m('p', null, '主营家用电器、家居家纺、电子产品、箱包皮具等生活用品。 '),
          ]),
          confirmButtonText: '确定',
        })
      },
      //去联系我们
      goContactUs() {
        const h = this.$createElement;
        this.$msgbox({
          title: '联系我们',
          message: h('p', null, [
            h('p', null, '公 司 名 称：北京金保通科技有限公司 ；'),
            h('p', null, '公 司 邮 箱：http://mail.ulic.com.cn/； '),
            h('p', null, '联 系 方 式：010-59949375 '),
          ]),
          confirmButtonText: '确定',
        });
      },
      //去资讯
      goNews() {
        this.$router.push({
          path: "/shopNews",
        })
      },
      //去商家入驻
      goEnter() {
        this.$router.push({
          path: "/shopEnter",
        })
      },
      //去首页
      goHome() {
        this.$router.push({
          path: "/",
        })
      },
      //打开收款码
      goQrCode() {
        this.isPayShow = true
      },
      //关闭收款码
      goClosePay() {
        this.isPayShow = false
      },
    }
  }

</script>
<style scoped>
  .shopNews {
    background-image: url(//img.alicdn.com/imgextra/i2/O1CN01OWa9L21QkSRmOrCaA_!!6000000002014-2-tps-720-1607.png);
    background-repeat: no-repeat;
    background-size: 100% 100%;
    height: auto;
    min-width: 1280px;
    width: 100%;
  }

  .shopTop {
    width: 100%;
    height: 3.2rem;
    display: flex;
    justify-content: space-around;
    align-items: center;
    border-bottom: 1px solid #fdfdfd;
  }

  .topLeft,
  .topRight {
    display: flex;
  }

  .login,
  .register,
  .aboutUs,
  .contactUs,
  .news {
    margin-right: 2rem;
  }

  .login {
    color: red;
  }

  .shopSearch {
    height: 6rem;
    display: flex;
    justify-content: space-around;
    align-items: center;
  }

  .shopLogo img {
    width: 10rem;
  }

  .search {
    width: 50%;
  }

  .shopGoods {
    width: 80%;
    margin: auto;
    margin-top: 2rem;
    display: flex;
    background: white;
    border-radius: 1rem;
    padding: 2rem;
  }

  .shopGoods img {
    width: 100%;
  }

  .pay {
    /* margin:0 auto; */
    padding: 2rem;
    text-align: center;
    position: absolute;
    top: 35%;
    left: 40%;
    background: #ea5413;
    border-radius: 1rem;
    color: white;
    font-size: 1.4rem;
  }

  .payQrCode img {
    width: 100%;
    margin: 1rem 0;
  }

  .payClose img {
    width: 15%;
  }
  .leftTitle{
    font-size: 2rem;
  }

  .leftCont {
    display: flex;
    padding: 2rem 0;
    border-bottom: 1px solid #ccc;
  }
  .leftCont img{
    width: 15rem;
    margin-right: 2rem;
  }
  .itemTitle{
    font-size: 1.4rem;
    font-weight: 700;
    display: flex;
    align-items: center;
  }
  .itemPayNum{
    margin-left: 1rem;
    font-size: 1rem;
    color: red;
  }
  .itemMsg{
    font-size: 1rem;
    margin-top: 1rem;
  }
  .itemPeople{
    font-size: 1rem;
    margin-top: 2rem;
  }

</style>



// WEBPACK FOOTER //
// shopNews.vue?a74942a2